import { useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { TLoadable, isLoaded, createLoaded, createUnloaded } from "../../../../sg-core";
import { selectHavainnotState } from "../selectors";
import { IRole } from "../../interfaces/IHavainnotUser";
import { useApplyParameters } from "../../data/context/useApplyParameters";

// SELECTORS
const selectContextState = createSelector(selectHavainnotState, (workPermit) => workPermit.context);

export const selectInitialContextLoaded = createSelector(
    selectContextState,
    (state) => state.initialContextLoaded,
);

// HOOKS
export const useInitialContextLoaded = (): TLoadable<boolean> =>
    useSelector(selectInitialContextLoaded) as any;

export const selectAppRolesById = createSelector(selectContextState, (state) => state.appRoles);

export const selectAppRoleList = createSelector(selectContextState, (state) => state.appRoleList);

export const selectAppConfgis = createSelector(selectContextState, (state) => state.appConfigs);

const selectAppRoles = createSelector(selectAppRoleList, selectAppRolesById, (listLoader, byId) => {
    if (isLoaded(listLoader)) {
        return createLoaded(listLoader.data.map((id) => byId[id]));
    }
    return createUnloaded();
});

export const useAppRoles = (): TLoadable<IRole[]> => useSelector(selectAppRoles);

export const useLoadAppParameters = () => {
    const configParams = useSelector(selectAppConfgis);
    const { apllyParameters } = useApplyParameters();
    const [loaded, setLoaded] = useState<boolean>(false);

    const paramsData = isLoaded(configParams) && configParams.data;

    useLayoutEffect(() => {
        if (!loaded && paramsData) {
            setLoaded(true);
            apllyParameters(paramsData);
        }
    }, [paramsData]);
};
